import utc from "dayjs/plugin/utc";

import DayJs from "dayjs";

DayJs.extend(utc);

export const getDeactivationDate = (date: Date) => {
  return DayJs(date).utcOffset(0).add(1, "day").startOf("day").format();
};
